export interface StripeProductSelectionMessageProps {
  heading?: string;
  message: string;
  isError?: boolean;
}

export const StripeProductSelectionMessage = ({ heading, message, isError }: StripeProductSelectionMessageProps) => {
  return (
    <div className="space-y-0.5 text-center">
      {!!heading && <p className={`text-sm font-semibold ${isError ? "text-destructive" : ""}`}>{heading}</p>}
      <p className={`text-sm ${isError ? "text-destructive" : "text-muted-foreground"}`}>{message}</p>
    </div>
  );
};
